import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../config/api';
import logo from '../../assets/logo.png';

// Handles shareable invite links like /join/ABC123.
// Looks up the session's mode automatically so partners/friends
// never have to manually type a 6-digit code — they just tap the link.
export default function JoinRedirectScreen() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function resolveSession() {
      const cleanCode = (code || '').trim().toUpperCase();
      if (!cleanCode || cleanCode.length !== 6) {
        setError('Invalid invite link.');
        return;
      }

      try {
        const { data } = await api.get(`/sessions/${cleanCode}`);
        const session = data.session || data;
        if (cancelled) return;

        if (!session || session.status === 'completed') {
          setError('This session has already ended.');
          return;
        }

        navigate('/preferences', {
          replace: true,
          state: { mode: session.mode || 'group', joinSessionCode: cleanCode },
        });
      } catch (err) {
        if (!cancelled) {
          setError('This session code is invalid or has expired.');
        }
      }
    }

    resolveSession();
    return () => { cancelled = true; };
  }, [code, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0d0d0d',
      color: '#fff',
      padding: '24px',
      textAlign: 'center',
    }}>
      <img src={logo} alt="Hangrily" style={{ height: '36px', marginBottom: '20px' }} />
      {error ? (
        <>
          <p style={{ fontSize: '16px', marginBottom: '16px' }}>{error}</p>
          <button
            className="btn btn-primary"
            style={{ padding: '10px 24px' }}
            onClick={() => navigate('/home')}
          >
            Go Home
          </button>
        </>
      ) : (
        <p style={{ fontSize: '15px', color: '#aaa' }}>Joining session…</p>
      )}
    </div>
  );
}
